import * as React from 'react'
import Navigation from './navigation'
const App: React.FC = () => <Navigation />

export default App
